import styled from "styled-components";

export const Style = styled.div`
  .modal {
    width: 100%;
    height: 95vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  h2 {
    font-weight: 500;
    color: #ffffff;
  }
  h2.title {
    padding: 10px 0 10px 10px;
    border-bottom: 1px solid #cecece;
  }

  .modal_header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 30px 20px 20px 20px;
    gap: 20px;
    border-bottom: 1px solid #555555;
    h2 {
      padding-left: 32px;
    }

    .settingButton {
      position: absolute;
      left: 14px;
      top: 14px;
      padding: 0;
      img {
        width: 40px;
        height: 40px;
      }
    }
  }

  .toggleWrap {
    display: flex;
    align-items: center;
    margin-bottom: 14px;
    .toggleItem {
      flex: 1;
      padding: 6px 0;
      background: #cecece;
      color: #ffffff;
      font-size: 20px;
      line-height: 30px;
      font-weight: 500;
    }
    .toggleItem.active {
      background: #4dd2ae;
    }
    .toggleItem:nth-child(1) {
      border-radius: 5px 0 0 5px;
    }
    .toggleItem:nth-child(2) {
      border-radius: 0 5px 5px 0;
    }
  }

  .modal_content {
    flex: 1;
    padding: 4% 8% 0 8%;
    height: 100%;

    .listWrap {
      padding: 4% 0;
      display: flex;
      height: auto;

      .sideListWrap {
        flex: 1;
        height: calc(76vh - 600px);

        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
        overflow-y: auto;
      }
    }
    .selectedButton {
      width: 80%;
      padding: 4%;
      border: 3px solid #343434;
      border-radius: 5px;
      text-align: center;
      h2 {
        white-space: nowrap;
      }
      h2.activeFloor {
        color: #4dd2ae;
      }
    }
    .selectedButton.activeArea {
      border: 3px solid #4dd2ae;
    }

    .deviceWrap {
      padding: 4% 0;
      h3 {
        font-weight: 500;
        padding-bottom: 8px;
      }
      .settingWrap {
        display: flex;
        gap: 8%;
        .settingItem {
          flex: 1;
        }
      }
      input {
        width: 100%;
        padding: 6px 16px;
        background: none;
        border: 1px solid #cecece;
        font-size: 20px;
        line-height: 30px;
        font-weight: 600;
        color: #fff;
        border-radius: 5px;
      }
      input:focus {
        outline-color: #4dd2ae;
      }
      input::placeholder {
        color: #737373;
      }
    }
  }

  .row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-top: 20px;
  }

  .submitButton {
    width: 100%;
    padding: 14px 0;
    border: 1px solid #4dd2ae;
    background: #4dd2ae;
    border-radius: 5px;
    color: #ffffff;
    font-size: 24px;
    line-height: 30px;
    font-weight: 600;
  }
  .submitButton.save {
    padding: 10px 0;
    margin-bottom: 4%;
  }

  .modal_footer {
    padding: 0 8% 6% 8%;

    .submitButton.cancel {
      border: 1px solid #a7a7a7;
      background: #343434;
      color: #cecece;
    }
    .submitButton.settings {
      margin: 14px 0;
      border: 1px solid #a7a7a7;
      background: #343434;
      color: #cecece;
    }
    .submitButton.off {
      background: gray;
      border-color: gray;
    }
  }
`;
